module.exports = __webpack_public_path__ + "static/img/72041B_2_3_4_R_2020123_fit.4a8988d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/72041B_2_3_4_R_2020123_fit.png
// module id = 7TKY
// module chunks = 0